var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgZoneAvilableIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38.24,
    height: 38.24,
    viewBox: "0 0 38.24 38.24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8932",
    "data-name": "Group 8932",
    transform: "translate(-40.681 -182.84)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8914",
    "data-name": "Path 8914",
    d: "M.8,0H36.438a.8.8,0,0,1,.8.8V36.438a.8.8,0,0,1-.8.8H.8a.8.8,0,0,1-.8-.8V.8A.8.8,0,0,1,.8,0Z",
    transform: "translate(78.421 183.34) rotate(90)",
    fill: "#fff",
    stroke: "gray",
    strokeWidth: 1,
    strokeDasharray: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_26",
    "data-name": "Union 26",
    d: "M-8609.582,1548v-6h-6v-4h6v-6h4v6h6v4h-6v6Z",
    transform: "translate(1599.623 8809.957) rotate(90)",
    fill: "#707070"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoneAvilableIcon);
export default __webpack_public_path__ + "static/media/zoneAvilableIcon.8f01f09306bf1d7ca5c52f29716809de.svg";
export { ForwardRef as ReactComponent };